import { PropsWithChildren } from 'react';
import {
    DesignSystemAlertSize,
    DesignSystemTypographyVariants,
} from '../../theme/design-system/types';
import { Typography } from '../Typography/Typography';
import { alertGridAreaContent } from './constants';
import { useSlotContext } from '../../utils/useSlotContext';

const mapAlertSizeToTypographyVariants: Record<
    DesignSystemAlertSize,
    DesignSystemTypographyVariants
> = {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
};

export const AlertContent = (props: PropsWithChildren) => {
    const {
        size,
        stacking,
        children,
        registeredComponents,
        contentToActionsGap,
    } = useSlotContext(props, 'alert');

    return (
        <Typography
            sx={{
                gridArea: alertGridAreaContent,
                // Add ellipsis for inline layout only
                ...(stacking === 'inline' && {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    minWidth: 0, // Allow grid to shrink below content size
                }),
                // Add bottom margin when actions are present in stacked layout
                ...(stacking === 'stacked' &&
                    registeredComponents?.has('actions') &&
                    contentToActionsGap !== undefined && {
                        marginBottom: contentToActionsGap,
                    }),
            }}
            variant={size ? mapAlertSizeToTypographyVariants[size] : 'xs'}
        >
            {children}
        </Typography>
    );
};
